import { Box3, Object3D, Vector3 } from 'three';

const SCALE_FACTOR = 10;

export type ModelSceneProperties = {
  boundingBox: Box3;
  center: Vector3;
  scale: number;
};

/**
 * Returns useful properties for rendering the given model
 */
export function getModelSceneProperties(model?: Object3D): ModelSceneProperties {
  if (model) {
    const boundingBox = new Box3().setFromObject(model);
    const center = boundingBox.getCenter(new Vector3());
    const scale = SCALE_FACTOR / boundingBox.getSize(new Vector3()).length();

    return { scale, center, boundingBox };
  }

  return { scale: 1, center: new Vector3(), boundingBox: new Box3() };
}
